import { ReactElement } from "react";
import "./styles.scss";

interface SectionProps {
  section: string;
  title: ReactElement | string;
  subtitle?: string;
  children: any;
  id?: string;
  bodyBG?: string;
}

export default function Section(props: SectionProps) {
  const { section, title, subtitle, children, id, bodyBG } = props;
  return (
    <div className="section-container-wrapper" id={id}>
      <div className="section-container">
        <p className="section-name">{section}</p>
        <div className="section-header">
          <p className="section-title">{title}</p>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
        </div>
        <div
          className={`section-body${bodyBG ? " with-bg" : ""}`}
          style={{ backgroundColor: bodyBG ?? undefined }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
